// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2o3H9","title":"styles_title__9r4Xr"};